module.exports = {
      id: "a0d48c39d28466c33e7df9c5b3c950c2kitchenEquipment-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#a0d48c39d28466c33e7df9c5b3c950c2kitchenEquipment-none.svg",
      toString: function () {
        return this.url;
      }
    }